import { useMutation, useQueryClient } from 'react-query';
import { API } from 'aws-amplify';
import { updateMeeting } from '../../graphql/mutations';
import QUERY_CACHE_KEY from '../../constants/QueryCacheKey';

function useRequestMeetingMutation(options = {}) {
  const client = useQueryClient();

  return useMutation(
    (input) => {
      return API.graphql({
        query: updateMeeting,
        variables: {
          input,
        },
      });
    },
    {
      ...options,
      onSuccess: (res) => {
        client.invalidateQueries(QUERY_CACHE_KEY.meetings());
        if ('function' === typeof options.onSuccess) {
          options.onSuccess(res);
        }
      },
    }
  );
}

export default useRequestMeetingMutation;
